// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .chat-window {
  position: fixed;
  bottom: 80px;
  right: 16px;
  width: 300px;
  height: 400px;
  display: flex;
  flex-direction: column;
  z-index: 9999;
  border: 1px solid #455e72;
} */
ion-fab {
  transition: transform 0.1s ease;
  touch-action: none;
}

ion-fab-button {
  --ripple-color: transparent;
  transition: none !important;
}

/* .chat-fab {
  position: absolute;
  z-index: 1000;
} */
.chat-fab {
  position: fixed;
  top: 0;
  left: 0;
  will-change: transform;
  touch-action: none;
}

/* Desktop: dentro del ion-app */
@media (min-width: 1025px) and (min-height: 769px) {
  ion-app {
    position: relative;
  }
  .chat-fab {
    position: absolute;
  }
}
.chat-window {
  bottom: 80px;
  margin-left: auto;
  margin-right: auto;
  width: 300px;
  max-height: 400px;
  height: 400px;
  top: 80px;
  display: flex;
  flex-direction: column;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.4s ease, transform 0.4s ease;
  pointer-events: none;
  z-index: 1000;
  border: 1px solid #455e72;
}
.chat-window.open {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}
.chat-window.closed {
  opacity: 0;
  transform: translateY(200px);
  pointer-events: none;
}

.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 12px;
}

.chat-header ion-card-title {
  margin: 0;
  font-size: 17px;
  font-weight: bold;
}

/* .title {
  text-align: center;
  font-weight: bold;
} */
.chat-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.chat-content .user {
  background: #455e72;
  color: white;
  margin: 4px 0;
  padding: 6px 10px;
  border-radius: 12px;
  align-self: flex-end;
  max-width: 80%;
}

.chat-content .assistant {
  background: #e5e5ea;
  color: black;
  margin: 4px 0;
  padding: 6px 10px;
  border-radius: 12px;
  align-self: flex-start;
  max-width: 80%;
}

.chat-input {
  display: flex;
  align-items: center;
  padding: 8px;
  border-top: 1px solid #ccc;
  color: black;
}

.chat-input ion-input {
  flex: 1;
  margin-right: 8px;
}

.bw-fab {
  --background: #000;
  /* Fondo negro */
  --color: #fff;
  /* Icono blanco */
  --background-activated: #333;
  /* Fondo gris al presionar */
  --background-hover: #222;
  /* Fondo gris al pasar mouse */
  --ripple-color: #fff;
  /* Efecto ripple blanco */
}

.btn__close {
  --background: black;
  width: 14px;
  height: 13px;
  max-height: 6px;
  min-height: 20px;
}

.typing-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
}

.typing-indicator span {
  width: 6px;
  height: 6px;
  background-color: #999;
  border-radius: 50%;
  margin: 0 2px;
  animation: blink 1.4s infinite both;
}

.typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/chat-bubble/chat-bubble.page.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;GAAA;AAWA;EACE,+BAAA;EACA,kBAAA;AACF;;AAEA;EACE,2BAAA;EACA,2BAAA;AACF;;AAEA;;;GAAA;AAKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kBAAA;AAAF;;AAGA,gCAAA;AACA;EACE;IACE,kBAAA;EAAF;EAGA;IACE,kBAAA;EADF;AACF;AAKA;EAGE,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,2BAAA;EACA,kDAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;AANF;AAQE;EACE,UAAA;EACA,wBAAA;EACA,oBAAA;AANJ;AASE;EACE,UAAA;EACA,4BAAA;EACA,oBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AARF;;AAWA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;AARF;;AAWA;;;GAAA;AAKA;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AATF;;AAYA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;AATF;;AAYA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,YAAA;AATF;;AAYA;EACE,OAAA;EACA,iBAAA;AATF;;AAYA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,4BAAA;EACA,4BAAA;EACA,wBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yBAAA;AATF;;AAYA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AATF;;AAYA;EACE,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mCAAA;AATF;;AAYA;EACE,qBAAA;AATF;;AAYA;EACE,qBAAA;AATF;;AAYA;EACE;IACE,YAAA;EATF;EAYA;IACE,UAAA;EAVF;EAaA;IACE,YAAA;EAXF;AACF","sourcesContent":["/* .chat-window {\n  position: fixed;\n  bottom: 80px;\n  right: 16px;\n  width: 300px;\n  height: 400px;\n  display: flex;\n  flex-direction: column;\n  z-index: 9999;\n  border: 1px solid #455e72;\n} */\nion-fab {\n  transition: transform 0.1s ease;\n  touch-action: none;\n}\n\nion-fab-button {\n  --ripple-color: transparent;\n  transition: none !important;\n}\n\n/* .chat-fab {\n  position: absolute;\n  z-index: 1000;\n} */\n\n.chat-fab {\n  position: fixed;\n  top: 0;\n  left: 0;\n  will-change: transform;\n  touch-action: none;\n}\n\n/* Desktop: dentro del ion-app */\n@media (min-width: 1025px) and (min-height: 769px) {\n  ion-app {\n    position: relative;\n  }\n\n  .chat-fab {\n    position: absolute;\n    //transform: translateX(-40px);\n  }\n}\n\n.chat-window {\n  //position: fixed;\n  //position: absolute;\n  bottom: 80px;\n  //right: 16px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 300px;\n  max-height: 400px;\n  height: 400px;\n  top: 80px;\n  display: flex;\n  flex-direction: column;\n  opacity: 0;\n  transform: translateY(20px);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n  pointer-events: none; // Evita clics cuando está invisible\n  z-index: 1000;\n  border: 1px solid #455e72;\n\n  &.open {\n    opacity: 1;\n    transform: translateY(0);\n    pointer-events: auto;\n  }\n\n  &.closed {\n    opacity: 0;\n    transform: translateY(200px);\n    pointer-events: none;\n  }\n}\n\n.chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 12px;\n}\n\n.chat-header ion-card-title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: bold;\n}\n\n/* .title {\n  text-align: center;\n  font-weight: bold;\n} */\n\n.chat-content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.chat-content .user {\n  background: #455e72;\n  color: white;\n  margin: 4px 0;\n  padding: 6px 10px;\n  border-radius: 12px;\n  align-self: flex-end;\n  max-width: 80%;\n}\n\n.chat-content .assistant {\n  background: #e5e5ea;\n  color: black;\n  margin: 4px 0;\n  padding: 6px 10px;\n  border-radius: 12px;\n  align-self: flex-start;\n  max-width: 80%;\n}\n\n.chat-input {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  border-top: 1px solid #ccc;\n  color: black;\n}\n\n.chat-input ion-input {\n  flex: 1;\n  margin-right: 8px;\n}\n\n.bw-fab {\n  --background: #000;\n  /* Fondo negro */\n  --color: #fff;\n  /* Icono blanco */\n  --background-activated: #333;\n  /* Fondo gris al presionar */\n  --background-hover: #222;\n  /* Fondo gris al pasar mouse */\n  --ripple-color: #fff;\n  /* Efecto ripple blanco */\n}\n\n.btn__close {\n  --background: black;\n  width: 14px;\n  height: 13px;\n  max-height: 6px;\n  min-height: 20px;\n}\n\n.typing-indicator {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n}\n\n.typing-indicator span {\n  width: 6px;\n  height: 6px;\n  background-color: #999;\n  border-radius: 50%;\n  margin: 0 2px;\n  animation: blink 1.4s infinite both;\n}\n\n.typing-indicator span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typing-indicator span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0.2;\n  }\n\n  20% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0.2;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
